import {
  HELP_DESK,
  ADMIN_ROLE,
  NONE_ROLE,
  OWNER_ROLE,
  VIEW_ROLE,
  CREATE,
  EDIT,
  ACCESS,
  VIEW,
  CLAIM_CERT,
  CONTACT,
  ACCOUNT,
  PROJECT,
  CONTRACT,
} from "./constants";
import API from "../server";

let _profile = {};

const PERMISSIONS = {
  [ACCOUNT]: {
    [ACCESS]: "isAdminOrOwner",
    [EDIT]: "isOwner",
  },
  [CONTACT]: {
    [CREATE]: "isAdminOrOwner",
    [EDIT]: "isAdminOrOwner",
  },
  [PROJECT]: {
    [CREATE]: "isAdminOrOwner",
    [EDIT]: () =>
      [ADMIN_ROLE, OWNER_ROLE, HELP_DESK].includes(
        specificRoles[PROJECT][EDIT],
      ),
  },
  [CONTRACT]: {
    [CREATE]: () =>
      [ADMIN_ROLE, OWNER_ROLE, HELP_DESK].includes(
        specificRoles[CONTRACT][CREATE],
      ),
    [EDIT]: () =>
      [ADMIN_ROLE, OWNER_ROLE, HELP_DESK].includes(
        specificRoles[CONTRACT][EDIT],
      ),
    [CLAIM_CERT]: () =>
      [ADMIN_ROLE, OWNER_ROLE].includes(specificRoles[CONTRACT][CLAIM_CERT]),
    [VIEW]: () => [VIEW_ROLE].includes(specificRoles[CONTRACT][VIEW]),
  },
};

const listPageActionsForProjectCheck = [
  [PROJECT, EDIT],
  [CONTRACT, CREATE],
].map((action) => JSON.stringify(action));

const shouldCheckProject = (page, action) => {
  return listPageActionsForProjectCheck.includes(
    JSON.stringify([page, action]),
  );
};

const listPageActionsForContractCheck = [
  [CONTRACT, EDIT],
  [CONTRACT, CLAIM_CERT],
  [CONTRACT, VIEW],
].map((action) => JSON.stringify(action));

const shouldCheckContract = (page, action) => {
  return listPageActionsForContractCheck.includes(
    JSON.stringify([page, action]),
  );
};

let checkedIds = {
  proId: "",
  contractId: "",
};

let specificRoles = {
  [PROJECT]: {
    [EDIT]: NONE_ROLE,
  },
  [CONTRACT]: {
    [CREATE]: NONE_ROLE,
    [EDIT]: NONE_ROLE,
    [CLAIM_CERT]: NONE_ROLE,
    [VIEW]: NONE_ROLE,
  },
};

export default {
  ..._profile,
  //account level
  setProfile(profile) {
    _profile = profile;
    Object.assign(this, _profile);
  },

  resetDefaultRoles() {
    checkedIds = {
      proId: "",
      contractId: "",
    };

    specificRoles = {
      [PROJECT]: {
        [EDIT]: NONE_ROLE,
      },
      [CONTRACT]: {
        [CREATE]: NONE_ROLE,
        [EDIT]: NONE_ROLE,
        [CLAIM_CERT]: NONE_ROLE,
        [VIEW]: NONE_ROLE,
      },
    };
  },

  isAdmin() {
    return this.role === ADMIN_ROLE;
  },

  isOwner() {
    return this.role === OWNER_ROLE;
  },

  isViewer() {
    return this.role === VIEW_ROLE;
  },

  isNone() {
    return this.role === NONE_ROLE;
  },

  isAdminOrOwner() {
    return this.isAdmin() || this.isOwner();
  },

  isFullPermission() {
    return true;
  },

  getPermissionRole(page, action) {
    return specificRoles?.[page]?.[action] || NONE_ROLE;
  },

  updateProjectRoles(proId) {
    return API.read_project_role(proId)
      .then((res) => res.data.data)
      .then((res) => {
        specificRoles[PROJECT][EDIT] = res.role;
        specificRoles[CONTRACT][CREATE] = res.role;
      });
  },

  updateContractInfo(proId, contractId) {
    return API.read_contract_role(proId, contractId)
      .then((res) => res.data.data)
      .then((res) => {
        specificRoles[CONTRACT][EDIT] = res.role;
        specificRoles[CONTRACT][CLAIM_CERT] = res.role;
        specificRoles[CONTRACT][VIEW] = res.role;
      });
  },

  async checkPermission(page, action, proId, contractId, refresh = false) {
    const permissions = PERMISSIONS[page];
    if (!permissions || !permissions[action]) {
      return false;
    }

    if (
      proId &&
      shouldCheckProject(page, action) &&
      (refresh || checkedIds.proId !== proId)
    ) {
      checkedIds.proId = proId;
      await this.updateProjectRoles(proId);
    }

    if (
      contractId &&
      shouldCheckContract(page, action) &&
      (refresh || checkedIds.contractId !== contractId)
    ) {
      checkedIds.contractId = contractId;
      await this.updateContractInfo(proId, contractId);
    }

    const check = permissions[action];
    if (typeof check === "function") {
      return check();
    }
    return this[check]();
  },

  async refreshCheckPermission(page, action, proId, contractId) {
    return this.checkPermission(page, action, proId, contractId, true);
  },
};
